export default __webpack_public_path__ + "3867c06.png";